import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
  ChangeDetectorRef,
} from "@angular/core";
import { environment } from "../../../environments/environment";
import { Feature } from "../../interfaces/feature";
import { Epic } from "../../interfaces/epic";
import { MzBaseModal } from "ng2-materialize";
import { Project } from "../../interfaces/project";
import { Utils } from "../../utils/utils";
import { EditThemeDialogComponent } from "../edit-theme-dialog/edit-theme-dialog.component";
import { Sprint } from "../../interfaces/sprint";

@Component({
  selector: "app-edit-item-dialog",
  templateUrl: "./edit-item-dialog.component.html",
  styleUrls: ["./edit-item-dialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditItemDialogComponent extends MzBaseModal implements OnInit {
  readonly env: any = environment;
  readonly utils: any = Utils;

  @Input() editThemeDialog: EditThemeDialogComponent;
  @Input() themes: Array<Epic>;
  @Input() project: Project;

  @Output() createItemClicked: EventEmitter<any> = new EventEmitter<any>();

  newItem: Feature;
  selectedTheme = "Epic auswählen" as string;

  constructor(private changeDetector: ChangeDetectorRef) {
    super();
  }

  ngAfterViewInit() {}

  ngOnInit() {
    this.newItem = {} as Feature;
  }

  /**
   * creates new Item
   */
  createItem() {
    if (this.newItem.name && this.newItem.name.trim() !== "") {
      this.newItem.projectId = this.project._id;
      this.createItemClicked.emit(this.newItem);
      this.newItem = {} as Feature;
      this.selectedTheme = "Epic auswählen";
    }
  }

  /**
   * resets newItem object and closes modal
   * @param modal
   */
  closeItemModal() {
    this.newItem = {} as Feature;
    this.selectedTheme = "Epic auswählen";
  }

  selectThemeId(themeId) {
    this.newItem.epicId = themeId;
  }

  setSelectedSprintID(sprintID: string, sprint: string) {
    this.newItem.sprint = sprintID;
  }

  setSelectedThemeID(themeID: string, theme: string) {
    this.selectedTheme = theme;
    this.newItem.epicId = themeID;
  }

  async addThemeClick() {
    this.modalComponent.close();
    let newTheme = await this.editThemeDialog.getResultAsync();
    if (newTheme) {
      this.newItem.epicId = newTheme._id;
      this.selectedTheme = newTheme.name;
    }
    this.modalComponent.open();
    this.changeDetector.detectChanges();
  }
  updateChanges() {
    this.changeDetector.detectChanges();
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/edit-item-dialog/edit-item-dialog.component.ts